import React, { useState, useEffect,useRef } from 'react';
import { Menu, X, Phone, Mail, Clock, Wrench,Scissors, Home, AlertCircle, Zap, Star, Award, Shield, Calculator, Search,Truck, ArrowLeft, Package, CloudRain, ChevronRight, ArrowRight, Users, Building, CheckCircle, TrendingUp, ChevronLeft, Grid, List, ShoppingCart, HardHat, PaintBucket, Droplets, Thermometer, Layers, Send, Calendar, DollarSign, Bath, Target, Hammer, Handshake, Cpu, Microscope, Quote, MapPin} from 'lucide-react';

import { Trabajo, Producto, Servicio, PhoneNumber } from '../types';

// ==================== FOOTER PROFESIONAL ====================
export default function Footer({ navigateToPage, openAccessibilityModal }: { navigateToPage: (page: string) => void; openAccessibilityModal: () => void }) {
  const yearsOfExperience = new Date().getFullYear() - 1998;

  // Enlaces reales <a href> (rastreables por Google) con navegación SPA
  const handleNavClick = (e: React.MouseEvent, page: string) => {
    e.preventDefault();
    navigateToPage(page);
  };

  return (
    <footer role="contentinfo" className="bg-[#1e3a5f] text-white pt-16 pb-8 border-t-[6px] border-blue-500 shadow-[0_-10px_20px_rgba(0,0,0,0.1)] relative overflow-hidden">
      <div className="absolute inset-0 bg-blue-900/20 pattern-grid opacity-20"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo y descripción */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3 mb-6">
              <img src="/logo_transparent.png" alt="José Luis Construcciones" className="h-20 w-auto object-contain filter drop-shadow-md" />
            </div>
            <p className="text-gray-200 text-sm leading-relaxed">
              Más de {yearsOfExperience} años de experiencia en el sector de la construcción y reformas.
            </p>
            <div className="flex space-x-4">
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Enlaces rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/"
                  onClick={(e) => handleNavClick(e, 'home')}
                  className="text-gray-300 hover:text-white transition-colors focus:outline-none focus:underline"
                >
                  Inicio
                </a>
              </li>
              <li>
                <a
                  href="/servicios"
                  onClick={(e) => handleNavClick(e, 'servicios')}
                  className="text-gray-300 hover:text-white transition-colors focus:outline-none focus:underline"
                >
                  Servicios
                </a>
              </li>
              <li>
                <a
                  href="/proyectos"
                  onClick={(e) => handleNavClick(e, 'proyectos')}
                  className="text-gray-300 hover:text-white transition-colors focus:outline-none focus:underline"
                >
                  Proyectos
                </a>
              </li>
              <li>
                <a
                  href="/contacto"
                  onClick={(e) => handleNavClick(e, 'contacto')}
                  className="text-gray-300 hover:text-white transition-colors focus:outline-none focus:underline"
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center text-gray-300">
                <Phone className="h-5 w-5 mr-2 text-blue-400 flex-shrink-0" aria-hidden="true" />
                <a href="tel:+34953039567" className="hover:text-white transition-colors focus:outline-none focus:underline">953 03 95 67</a>
              </li>
              <li className="flex items-center text-gray-300">
                <Phone className="h-5 w-5 mr-2 text-blue-400 flex-shrink-0" aria-hidden="true" />
                <a href="tel:+34650441396" className="hover:text-white transition-colors focus:outline-none focus:underline">650 44 13 96</a>
              </li>
              <li className="flex items-center text-gray-300">
                <Mail className="h-5 w-5 mr-2 text-blue-400 flex-shrink-0" aria-hidden="true" />
                <a href="mailto:construccionesperezrosa@gmail.com" className="hover:text-white transition-colors focus:outline-none focus:underline break-all">construccionesperezrosa@gmail.com</a>
              </li>
              <li className="flex items-center text-gray-300">
                <MapPin className="h-5 w-5 mr-2 text-blue-400 flex-shrink-0" aria-hidden="true" />
                <span>C. Ing. García Pimentel, 37 - Martos, Jaén</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Horario</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-300">
                Lunes - Viernes
                <br />
                <span className="font-semibold text-white">9:00 - 14:00 y 17:00 - 20:00</span>
              </li>
              <li className="text-gray-300">
                Sábado - Domingo
                <br />
                <span className="font-semibold text-white">Cerrado</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-300">
          <p className="text-sm">&copy; {new Date().getFullYear()} José Luis Construcciones. Todos los derechos reservados.</p>
          <div className="mt-4 flex flex-wrap justify-center gap-x-6 gap-y-2">
            <a
              href="/privacidad"
              onClick={(e) => handleNavClick(e, 'privacidad')}
              className="text-gray-300 hover:text-white transition-colors text-xs underline focus:outline-none focus:text-white"
            >
              Política de Privacidad
            </a>
            <a
              href="/cookies"
              onClick={(e) => handleNavClick(e, 'cookies')}
              className="text-gray-300 hover:text-white transition-colors text-xs underline focus:outline-none focus:text-white"
            >
              Política de Cookies
            </a>
            <a
              href="/aviso-legal"
              onClick={(e) => handleNavClick(e, 'aviso-legal')}
              className="text-gray-300 hover:text-white transition-colors text-xs underline focus:outline-none focus:text-white"
            >
              Aviso Legal y Condiciones
            </a>
            <button 
              onClick={openAccessibilityModal}
              className="text-gray-300 hover:text-white transition-colors text-xs underline focus:outline-none focus:text-white"
            >
              Accesibilidad
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}